import RegularClassScheduleProvider from "src/provider/regularClassScheduleProvider";
import { BusRidingListFilter } from "./bus-riding-list-filter";
import RegularClassProvider from "src/provider/regularClassProvider";
import { useState } from "react";
import moment from "moment";
import { useAttendancesQuery } from "src/services/react-query-apis/get-attendances";
import RidingListTable from "./riding-list-table";
import Loader from "src/components/common/Loader/Loader";

export const RidingList = () => {
  return (
    <RegularClassScheduleProvider>
      <RegularClassProvider>
        <RidingListBody />
      </RegularClassProvider>
    </RegularClassScheduleProvider>
  );
};

const RidingListBody = () => {
  const [filterData, setFilterData] = useState({
    attendance_date: moment().format("YYYY-MM-DD"),
    bus_schedule_id: 0,
  });

  const attendancesQuery = useAttendancesQuery({
    start_date: filterData.attendance_date,
    end_date: filterData.attendance_date,
    bus_schedule_id: filterData.bus_schedule_id,
    reschedulable_only: 0,
    bus_only: 0,
    queryConfig: {
      enabled: !!(filterData.attendance_date && filterData.bus_schedule_id),
    },
  });

  let ridingListTable = null;

  if (attendancesQuery.isPending) {
    ridingListTable = (
      <div>
        <Loader message="バス乗車名簿を取得中..." />
      </div>
    );
  } else if (attendancesQuery.isError) {
    ridingListTable = <div>バスデータの取得に失敗しました</div>;
  } else if (!attendancesQuery.data?.data?.length) {
    ridingListTable = <div>この日にバス乗車の生徒はいません</div>;
  } else {
    ridingListTable = (
      <RidingListTable
        date={filterData.attendance_date}
        busScheduleId={Number(filterData.bus_schedule_id)}
        attendances={attendancesQuery.data?.data}
      />
    );
  }

  return (
    <div style={{ width: "65%" }}>
      <div className="card-body">
        <div className="card">
          <div className="card-header d-flex align-items-center">
            <div style={{ fontSize: "1.2rem", fontWeight: "bold" }}>
              バス乗車名簿
            </div>
          </div>
          <div className="p-3">
            <BusRidingListFilter onSubmit={setFilterData} />
          </div>
        </div>
        <div style={{ marginTop: "10px" }}>
          {!!filterData.bus_schedule_id && ridingListTable}
        </div>
      </div>
    </div>
  );
};

export default RidingList;
